// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__7206x","content":"Header_content__XUl4A","user":"Header_user__z2Tee"};